import styled from "styled-components";

export const TitleWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

export const EmailText = styled.span`
  word-break: normal;
`;
